module.exports = __webpack_public_path__ + "static/img/nine1.a20df068.jpg";